import { Text } from '@chakra-ui/react'
import PropTypes from 'prop-types'
import React, { useMemo } from 'react'
import UnderlineHeading from '../UnderlineText/UnderlineHeading'

const titleTypesComponents = {
  overline: Text,
  subtitle3: Text,
  subtitle2: Text,
  subtitle1: Text,
  underline: UnderlineHeading,
}

const titleVariants = {
  subtitle3: 'subtitle3',
  subtitle2: 'subtitle2',
  subtitle1: 'subtitle1',
  overline: 'overline',
  underline: 'h5',
}

export default function TextFactory({ title, titleType }) {
  const TextComponent = useMemo(
    () => titleTypesComponents[titleType],
    [titleType],
  )

  return (
    (title && (
      <TextComponent mb="8px" variant={titleVariants[titleType]}>
        {title}
      </TextComponent>
    )) ||
    null
  )
}

TextFactory.propTypes = {
  title: PropTypes.string,
  titleType: PropTypes.string,
}
